<template>
  <div class="modal">
    <a  class="modal_close" @click="$emit('close')"></a>
    <div class="modal_body">
      <div class="ico_box bang">
      </div>
      <p class=common_txt v-html="message">
      </p>
      <div class="common_btn">
        <button type="button" class="btn_ok" @click="$emit('close')">취소</button>
        <button type="button" class="btn_ok" @click="$emit('confirm')">확인</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: { type: String, default: '' },
  },
};
</script>